import React from 'react';
import { Icon } from '../icon';

// styles
import css from './imagePlaceholder.sss';

// images
import PictureIconSvg from './images/picture.icon.svg';


export const ImagePlaceholder = (props) => (
    <span className={css.root}>
        <Icon
            className={css.icon}
            glyph={props.glyph || PictureIconSvg}
        />
    </span>
);
